import { StrictFetcher } from '@this/src/util';
import React from 'react';
import _ from 'lodash';

import MarginType from '@this/domain/organization/margin_type2';
import HotelList from '@this/domain/hotel/hotel_list';
import HotelModel from '@this/domain/hotel/hotel';
import type { HotelState } from './types';

import HotelPcTemplate from './hotel_pc.template';
import HotelSpTemplate from './hotel_sp.template';
import type { HotelResponse } from '../reserve_trip/select/hotel_box/hotel_candidate_box';

interface HotelProps {
  serviceId?: number | null;
}

class Hotel extends React.Component<HotelProps, HotelState> {
  constructor(props: HotelProps) {
    super(props);

    this.state = {
      showPropertyAmenities: false,
      showRoomAmenities: false,
      loading: true,
      error: null,
      serviceId: props.serviceId || 1,
      searchQueryId: null
    };
  }

  componentDidMount() {
    const p = utils.getParams();
    this.setState({ destLocation: { lat: parseFloat(p.lat), lng: parseFloat(p.lng) } });
    return StrictFetcher.get<HotelResponse>(location.pathname, 'hotels/show.json').then(
      result => {
        const hotels = new HotelList();
        let marginType: MarginType | undefined;
        if (result.margin_type) {
          marginType = new MarginType(result.margin_type);
        }
        const hotel = new HotelModel(_.merge(result.hotel, { showFee: result.show_fee, marginType }));
        if (this.state.destLocation) hotel.fetchDistance(this.state.destLocation);
        hotels.list = [hotel];
        return this.setState({
          hotels,
          hotel,
          loading: false,
          error: null
        });
      },
      e => {
        const error =
          e.status === 404
            ? 'ページが見つかりません。URLを確認してください。'
            : utils.dig(e, 'responseJSON', 'error')
            ? utils.dig(e, 'responseJSON', 'error')
            : '通信環境が不安定です。\n時間をおいてもう一度お試しください。';
        return this.setState({
          loading: false,
          error
        });
      }
    );
  }

  getPropertyAmenities = () => {
    const amenities = this.state.hotel && this.state.hotel.propertyAmenities();
    if (this.state.showPropertyAmenities) {
      return amenities || [];
    }

    return (amenities && amenities.slice(0, 10)) || [];
  };

  getRoomAmenities = () => {
    const amenities = this.state.hotel && this.state.hotel.roomAmenities();
    if (this.state.showRoomAmenities) {
      return amenities || [];
    }

    return (amenities && amenities.slice(0, 10)) || [];
  };

  getImages = () => {
    const images = (this.state.hotel && this.state.hotel.images) || [];

    return images.slice(0, 26);
  };

  togglePropertyAmenities = () => {
    this.setState({ showPropertyAmenities: !this.state.showPropertyAmenities });
  };

  toggleRoomAmenities = () => {
    this.setState({ showRoomAmenities: !this.state.showRoomAmenities });
  };

  handleImageHover = (i: number) => () => {
    if (this.state.hotel) {
      return this.state.hotel.selectImage(i);
    }
    return undefined;
  };

  render() {
    try {
      return (
        <div className="hotel">
          <div className="hotel__pc">
            <HotelPcTemplate
              {...this.state}
              getPropertyAmenities={this.getPropertyAmenities}
              getRoomAmenities={this.getRoomAmenities}
              getImages={this.getImages}
              togglePropertyAmenities={this.togglePropertyAmenities}
              toggleRoomAmenities={this.toggleRoomAmenities}
              handleImageHover={this.handleImageHover}
            />
          </div>
          <div className="hotel__sp">
            <HotelSpTemplate
              {...this.state}
              getPropertyAmenities={this.getPropertyAmenities}
              getRoomAmenities={this.getRoomAmenities}
              getImages={this.getImages}
              togglePropertyAmenities={this.togglePropertyAmenities}
              toggleRoomAmenities={this.toggleRoomAmenities}
            />
          </div>
        </div>
      );
    } catch (e) {
      return null;
    }
  }
}

export default Hotel;
